import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-jewel.mjs";
import { render } from "lit-html";
import {
    getLocation,
    wait,
    VAULT,
    linkify,
    unlinkify,
    getRandomNumber
} from "../../global.ts";
import { Chests } from "../../../models/Chests.ts";
import { Speech } from "../../../models/Speech.ts";
import { Stamps } from "../../../models/Stamps.ts";
import { Media } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbDialog } from "../hb-dialog/hb-dialog.ts";
import { HbMain } from "../hb-main.ts";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

import Stock from "./Vault.json";
const stock: { category: string; folder: string; count: number }[] = Stock;

// NO SOUND bc need user interaction

// TODO: begin with random jewel in category of the current holiday season!!! default: thank you
const HOLIDAY = 0; // 0 = thank you

export class HbJewel extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private media = new Media();
    private stamps = new Stamps();
    private chests = new Chests();
    private speech = new Speech();
    private modal: ModalInterface;
    private dialog: HbDialog;
    private main = document.querySelector("hb-main") as HbMain; // for ai spinner

    private jewel: HTMLElement;
    private stamp: HTMLButtonElement;
    private form: HTMLFormElement;
    private back: HTMLButtonElement;
    private mint: HTMLButtonElement;
    private skip: HTMLButtonElement; // not used
    private message: HTMLParagraphElement;

    private stock: HTMLElement;
    private stockBtn: HTMLButtonElement;
    private search: HTMLInputElement;
    private searchCategory: HTMLElement;
    private searchCategories: HTMLUListElement;
    private searchBtn: HTMLButtonElement;
    private stockVideo: HTMLVideoElement;
    private stockMessage: HTMLParagraphElement;

    private controls: HTMLElement;
    private page: HTMLElement;
    private previous: HTMLButtonElement;
    private next: HTMLButtonElement;

    private ai: HTMLElement;
    private aiBtn: HTMLButtonElement;
    private prompt: HTMLInputElement;
    private promptBtn: HTMLButtonElement;
    private aiVideo: HTMLVideoElement;
    private aiMessage: HTMLParagraphElement;

    private stockCategory = stock[HOLIDAY].folder;
    private stockItem = getRandomNumber(1, stock[HOLIDAY].count);
    private stockCount = stock[HOLIDAY].count;

    private aiItem = 0;
    private aiCount = 0;

    constructor() {
        super();
        render(template(null), this);

        this.dialog = this.querySelector("hb-dialog")!;
        this.jewel = this.querySelector("#hb-jewel")!;
        this.stamp = this.querySelector("#hb-jewel-stamp")!;
        this.form = this.querySelector("#hb-jewel-form")!;
        this.back = this.querySelector("#hb-jewel-back")!;
        this.mint = this.querySelector("#hb-jewel-mint")!;
        this.skip = this.querySelector("#hb-jewel-skip")!;
        this.message = this.querySelector("#hb-jewel-message")!;

        this.stock = this.querySelector("#hb-jewel-stock")!;
        this.stockBtn = this.querySelector("#hb-jewel-art-stock")!;
        this.search = this.querySelector("#hb-jewel-stock-search")!;
        this.searchCategory = this.querySelector("#hb-jewel-stock-categories")!;
        this.searchCategories = this.searchCategory
            .firstElementChild as HTMLUListElement;
        this.searchBtn = this.querySelector("#hb-jewel-stock-magic")!;
        this.stockVideo = this.querySelector("#hb-jewel-stock-video")!;
        this.stockMessage = this.querySelector("#hb-jewel-stock-message")!;

        this.controls = this.querySelector("#hb-jewel-art-controls")!;
        this.page = this.querySelector("#hb-jewel-art-page")!;
        this.previous = this.querySelector("#hb-jewel-art-previous")!;
        this.next = this.querySelector("#hb-jewel-art-next")!;

        this.ai = this.querySelector("#hb-jewel-ai")!;
        this.aiBtn = this.querySelector("#hb-jewel-art-ai")!;
        this.prompt = this.querySelector("#hb-jewel-ai-prompt")!;
        this.promptBtn = this.querySelector("#hb-jewel-ai-magic")!;
        this.aiVideo = this.querySelector("#hb-jewel-ai-video")!;
        this.aiMessage = this.querySelector("#hb-jewel-ai-message")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.stockVideo.pause();
                this.aiVideo.pause();
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockVideo.paused) this.stockVideo.play();
                //if (this.aiVideo.paused) this.aiVideo.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-jewel",
            override: true
        };

        this.modal = new Modal(this.jewel, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //this.renderStock();

        this.stamp.addEventListener("click", () => {
            if (
                confirm(
                    "Are you sure you want to un-link the B-Stamp you scanned?"
                )
            ) {
                localStorage.removeItem("stamp");
                this.renderStamp();
            }
        });

        this.back.addEventListener(
            "click",
            () => (window.location.hash = "#/mint/silver")
        );

        this.aiBtn.addEventListener("click", () => {
            //this.aiVideo.muted = false;
            this.stockVideo.pause();
            this.aiVideo.play();
            this.aiBtn.classList.add("underline");
            this.stockBtn.classList.remove("underline");
            this.controls.classList.add("hidden");
            this.stock.classList.add("hidden");
            this.ai.classList.remove("hidden");
            //this.mint.classList.add("hidden");
            //this.prompt.focus();
        });
        this.stockBtn.addEventListener("click", () => {
            //this.stockVideo.muted = false;
            this.aiVideo.pause();
            this.stockVideo.play();
            this.aiBtn.classList.remove("underline");
            this.stockBtn.classList.add("underline");
            this.controls.classList.remove("hidden");
            this.stock.classList.remove("hidden");
            this.ai.classList.add("hidden");
            //this.mint.classList.remove("hidden");
            //this.search.focus();
        });

        this.previous.addEventListener("click", () => {
            //this.stockVideo.pause();
            this.goToStock(false);
        });
        this.next.addEventListener("click", () => {
            //this.stockVideo.pause();
            this.goToStock(true);
        });

        //this.skip.addEventListener("click", (event) => this.publish(event));
        this.form.addEventListener("submit", this.publish.bind(this));

        this.aiVideo.addEventListener("click", this.preview.bind(this));
        this.stockVideo.addEventListener("click", this.preview.bind(this));
        this.message.addEventListener("click", this.preview.bind(this));

        this.search.addEventListener("focus", () => {
            this.renderCategories(this.search.value);
            this.searchCategory.classList.remove("hidden");
        });
        this.search.addEventListener("blur", async () => {
            await wait(0.1); // needed for click select
            this.searchCategory.classList.add("hidden");
        });
        this.search.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.renderCategory();
            }
        });
        this.search.addEventListener("keyup", (event: KeyboardEvent) => {
            this.renderCategories(this.search.value);
        });
        this.searchBtn.addEventListener(
            "click",
            this.renderCategory.bind(this)
        );

        // deprecated
        // this.stockMessage.addEventListener("click", async () => {
        //     if (this.stockVideo.paused) {
        //         this.stockVideo.play();
        //     } else {
        //         this.stockVideo.pause();
        //     }
        // });
        // this.stockVideo.addEventListener("play", () => {
        //     const silver = localStorage.getItem("silver") || "Thank You";
        //     //this.stockMessage.textContent = silver;
        //     //this.stockMessage.classList.remove("hidden");

        //     this.speech.speak(unlinkify(silver), () => {
        //         this.stockVideo.pause();
        //         //this.stockMessage.classList.add("hidden");
        //     });
        // });
        // this.stockVideo.addEventListener("pause", () => {
        //     this.speech.pause();
        // });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
        });
    }

    private renderCategory() {
        if (this.searchCategories.childElementCount > 0) {
            const item = this.searchCategories
                .firstElementChild as HTMLLIElement;
            this.stockCategory = item.dataset.category!;
            this.stockItem = 1;
            this.stockCount = parseInt(item.dataset.count!);
            this.renderStock();
            this.search.blur();
        }
    }

    private renderCategories(search: string) {
        this.searchCategories.innerHTML = "";
        for (const item of stock)
            if (
                search === "" ||
                item.category
                    .toLowerCase()
                    .includes(search.trim().toLowerCase())
            ) {
                const li = document.createElement("li");
                li.classList.add(
                    "block",
                    "px-4",
                    "py-2",
                    "hover:bg-gray-100",
                    "dark:hover:bg-gray-600",
                    "dark:hover:text-white"
                );
                li.dataset.category = item.folder;
                li.dataset.count = item.count.toString();
                li.textContent = item.category;
                li.onclick = () => {
                    this.stockCategory = item.folder;
                    this.stockItem = 1;
                    this.stockCount = item.count;
                    this.search.value = "";
                    this.search.placeholder = item.category;
                    this.renderStock();
                };
                this.searchCategories.appendChild(li);
            }

        if (this.searchCategories.childElementCount === 0) {
            const li = document.createElement("li");
            li.classList.add(
                "block",
                "px-4",
                "py-2",
                "text-gray-500",
                "dark:text-gray-400"
            );
            li.textContent = "No Categories Found";
            this.searchCategories.appendChild(li);
        }
    }

    private async preview() {
        const chest = await this.chests.getDraft();
        window.location.hash = `#/chest/${chest!.id}/minting`;
    }

    // TODO: show spinner if await is too long
    async show() {
        await this.renderStock();
        if (this.stockVideo.paused) this.stockVideo.play();
        if (this.aiVideo.paused) this.aiVideo.play();

        // const silver = localStorage.getItem("silver") || "Thank You";
        // this.stockMessage.innerHTML = linkify(silver);
        // this.stockMessage.classList.remove("hidden");

        this.message.textContent = `Tap to preview this Silver ${
            localStorage.getItem("storage") === "cloud"
                ? "B-Chest"
                : localStorage.getItem("storage") === "code"
                  ? "QR Code"
                  : "3B Crystal"
        } from your point of view`;

        this.stockBtn.click();
        await this.saveDraft();
        await this.renderStamp();
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private async renderStamp() {
        const storage = localStorage.getItem("storage");
        const stamp = localStorage.getItem("stamp");
        const isStamp =
            stamp &&
            storage === "cloud" &&
            !(await this.stamps.isMinted(stamp));
        this.stamp.classList.toggle("hidden", !isStamp);
    }

    private async renderStock() {
        const item = this.page.firstElementChild as HTMLSpanElement;
        const total = this.page.lastElementChild as HTMLSpanElement;
        //console.log(this.stockCategory, this.stockItem, this.stockCount);

        item.textContent = this.stockItem.toString();
        total.textContent = this.stockCount.toString();

        //this.stockMessage.classList.add("hidden");
        this.stockVideo.poster = `${VAULT}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.jpg`;
        this.stockVideo.src = `${VAULT}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.mp4`;
        await this.saveDraft();
    }

    private goToAI(direction: boolean) {}

    private async goToStock(direction: boolean) {
        if (direction) {
            if (this.stockItem < this.stockCount) {
                ++this.stockItem;
            } else {
                this.stockItem = 1;
            }
        } else {
            if (this.stockItem > 1) {
                --this.stockItem;
            } else {
                this.stockItem = this.stockCount;
            }
        }

        await this.renderStock();
        this.stockVideo.muted = false;
    }

    // skip is deprecated
    private async saveDraft(skip = false) {
        // store jewel selection and chest in dexie or cloud
        const uid = this.heartbank.user?.uid || "";

        //step 1
        const ship = localStorage.getItem("ship") || ""; // ship name
        const location = getLocation(); // decrypted location

        //step 2
        const address = localStorage.getItem("address") || ""; // from public key
        const silver = localStorage.getItem("silver") || ""; // decrypted message
        const treasure = localStorage.getItem("treasure") || ""; // data

        // TODO: later ai // link to firebase storage
        const data = skip
            ? `B:/${treasure}`
            : `B:/${treasure}/${this.stockCategory}/${this.stockItem}`;
        const coverPoster = this.stockVideo.poster;
        const coverVideo = this.stockVideo.src;

        const chest = await this.chests.getDraft();
        await this.chests.mint(
            ship,
            uid,
            data,
            address,
            { a: location.a, t: location.t, g: location.g },
            silver,
            coverPoster,
            coverVideo,
            "minting",
            chest ? chest.id : undefined
        );
    }

    private async clearForm(id: string) {
        const data = JSON.parse(
            decodeURIComponent(localStorage.getItem("treasure") || "{}")
        );

        // step 1
        //const media = JSON.parse(localStorage.getItem("media") || "{}"); // decrypted diamonds // should always exist
        const trove: any = JSON.parse(localStorage.getItem("trove") || "[]");
        for (const [index, jewelry] of trove.entries()) {
            if (jewelry.l && !jewelry.i && !this.heartbank.user) {
                // skip and don't delete
            } else {
                switch (localStorage.getItem("storage")) {
                    case "cloud":
                        // remove all local
                        if (jewelry.d) {
                            await this.media.deleteFileFromOPFS(
                                jewelry.n,
                                jewelry.d
                            );
                        }
                        if (jewelry.f)
                            await this.media.deleteFileFromOPFS(
                                jewelry.n,
                                jewelry.f
                            );
                        break;
                    case "code":
                        // remove all local
                        if (jewelry.d)
                            await this.media.deleteFileFromOPFS(
                                jewelry.n,
                                jewelry.d
                            );
                        if (jewelry.f)
                            await this.media.deleteFileFromOPFS(
                                jewelry.n,
                                jewelry.f
                            );
                        break;
                    case "crystal":
                        // store in dexie
                        await this.chests.addDiamond(id, {
                            n: jewelry.n,
                            s: jewelry.s,
                            i: jewelry.i,
                            l: jewelry.l,
                            f: jewelry.d
                                ? await this.media.getFileFromOPFS(
                                      jewelry.n,
                                      jewelry.d
                                  )
                                : undefined
                        });
                        // transfer all local
                        if (data.d?.e) {
                            if (jewelry.d)
                                await this.media.deleteFileFromOPFS(
                                    jewelry.n,
                                    jewelry.d
                                );
                            if (jewelry.f)
                                await this.media.moveFileInOPFS(
                                    jewelry.n,
                                    jewelry.f,
                                    `chests/${id}/${jewelry.d}` // not f: same folder as decrypted
                                );
                        } else {
                            if (jewelry.d)
                                await this.media.moveFileInOPFS(
                                    jewelry.n,
                                    jewelry.d,
                                    `chests/${id}/${jewelry.d}`
                                );
                            if (jewelry.f)
                                await this.media.deleteFileFromOPFS(
                                    jewelry.n,
                                    jewelry.f
                                );
                        }
                        break;
                }
                // remove duplicate from cloud storage: if encrypted, keep both; else, delete encrypted
                if (data.d?.e) {
                    if (jewelry.l && !jewelry.i) {
                        await this.chests.addCloudDiamond(id, {
                            n: jewelry.n,
                            s: jewelry.s,
                            l: jewelry.l
                        });
                        //await removeFile(jewelry.l);
                    }
                } else {
                    if (jewelry.e) await this.media.removeFile(jewelry.e);
                }
                trove.splice(index, 1);
            }
        }
        localStorage.removeItem("ship"); // ship name
        //localStorage.removeItem("location"); // location
        localStorage.setItem("trove", JSON.stringify(trove));
        localStorage.removeItem("media"); // diamonds
        localStorage.removeItem("timelock");

        // step 2
        const voice = JSON.parse(localStorage.getItem("voice") || "{}");
        if (voice.l && !this.heartbank.user) {
            // don't delete
        } else {
            switch (localStorage.getItem("storage")) {
                case "cloud":
                    // remove all local
                    if (voice.n)
                        await this.media.deleteFileFromOPFS(voice.n, "voice");
                    if (voice.f)
                        await this.media.deleteFileFromOPFS(voice.f, "voice");
                    break;
                case "code":
                    // remove all local
                    if (voice.n)
                        await this.media.deleteFileFromOPFS(voice.n, "voice");
                    if (voice.f)
                        await this.media.deleteFileFromOPFS(voice.f, "voice");
                    break;
                case "crystal":
                    // store in dexie
                    if (voice.n)
                        await this.chests.updateVoice(id, {
                            l: voice.l,
                            f: await this.media.getFileFromOPFS(
                                voice.n,
                                "voice"
                            )
                        });
                    // transfer all local
                    if (data.n.e) {
                        if (voice.n)
                            await this.media.deleteFileFromOPFS(
                                voice.n,
                                "voice"
                            );
                        if (voice.f)
                            await this.media.moveFileInOPFS(
                                voice.f,
                                "voice",
                                `chests/${id}/voice`
                            );
                    } else {
                        if (voice.n)
                            await this.media.moveFileInOPFS(
                                voice.n,
                                "voice",
                                `chests/${id}/voice`
                            );
                        if (voice.f)
                            await this.media.deleteFileFromOPFS(
                                voice.f,
                                "voice"
                            );
                    }
                    break;
            }
            // remove duplicate from cloud storage: if encrypted, keep both; else delete encrypted
            if (data.n.e) {
                if (voice.l) {
                    await this.chests.updateCloudVoice(id, {
                        l: voice.l
                    });
                    //await removeFile(voice.l);
                }
            } else {
                if (voice.e) await this.media.removeFile(voice.e);
            }
            localStorage.removeItem("voice");
        }
        //localStorage.removeItem("address"); // from public key
        localStorage.removeItem("silver"); // message
        localStorage.removeItem("treasure"); // data
        localStorage.removeItem("recipients");

        // step 3
        // keep same jewel selection // or reset to thank you category?
    }

    // possible to publish multiple times by using back button: but ok bc need passkey again
    private async publish(event: Event) {
        event.preventDefault();
        this.dialog.show("jewel");

        let id = "";
        const chest = (await this.chests.getDraft())!; // has to exist
        const storage = localStorage.getItem("storage") || ""; // cloud, code, crystal
        const stamp = localStorage.getItem("stamp");

        switch (storage) {
            case "cloud":
                id = await this.chests.cloudMint(
                    chest.name,
                    chest.uid,
                    chest.data,
                    chest.address,
                    chest.location,
                    chest.message,
                    chest.coverPoster,
                    chest.coverVideo
                    //!!(stamp && storage === "cloud" && this.heartbank.user)
                );

                //localStorage.setItem("chest", id); // pro not used
                this.dialog.renderMessage(
                    "Now storing your Silver B-Chest inside your Cloud Vault..."
                );
                await wait(1);
                this.dialog.render1a(true);
                await wait(1);
                this.dialog.render1b(true);

                this.dialog.renderMessage(
                    "Now publishing your Silver B-Chest on the Aquarius™ Blockchain to make it freely and publicly digestible by any AI, for the benefit of humanity..."
                );
                await wait(1);
                this.dialog.render2a(true);
                await wait(1);
                this.dialog.render2b(true);
                break;
            case "code":
                id = await this.chests.mint(
                    chest.name,
                    chest.uid,
                    chest.data,
                    chest.address,
                    chest.location,
                    chest.message,
                    chest.coverPoster,
                    chest.coverVideo,
                    "mint"
                );
                this.dialog.renderMessage(
                    "Now storing a backup copy of your Silver QR Code inside your Titanium Vault..."
                );
                await wait(1);
                this.dialog.render1a(true);
                await wait(1);
                this.dialog.render1b(true);

                this.dialog.renderMessage(
                    "To respect your privacy, publishing your Silver QR Code on the Aquarius™ Blockchain is skipped..."
                );
                await wait(1);
                this.dialog.render2a(true);
                await wait(1);
                this.dialog.render2b(true);
                break;
            case "crystal":
                id = await this.chests.mint(
                    chest.name,
                    chest.uid,
                    chest.data,
                    chest.address,
                    chest.location,
                    chest.message,
                    chest.coverPoster,
                    chest.coverVideo,
                    "mint"
                );
                this.dialog.renderMessage(
                    "Now storing a backup copy of your Silver 3B Crystal inside your Titanium Vault..."
                );
                await wait(1);
                this.dialog.render1a(true);
                await wait(1);
                this.dialog.render1b(true);

                this.dialog.renderMessage(
                    "To respect your privacy, publishing your Silver 3B Crystal on the Aquarius™ Blockchain is skipped..."
                );
                await wait(1);
                this.dialog.render2a(true);
                await wait(1);
                this.dialog.render2b(true);
                break;
        }

        if (
            stamp &&
            storage === "cloud" &&
            this.heartbank.user &&
            !(await this.stamps.isMinted(stamp))
        ) {
            this.dialog.renderMessage(
                "Now linking your scanned Silver B-Stamp to this Silver B-Chest..."
            );
            await this.stamps.link(stamp, this.heartbank.user.uid, id);
            localStorage.removeItem("stamp");
            //await wait(1);
        } else {
            this.dialog.renderMessage(
                "Now adorning your Silver B-Chest with this Jewel..."
            );
            await wait(1);
        }
        this.dialog.render3a(true);
        await this.clearForm(id);
        this.dialog.render3b(true);

        this.dialog.hide();
        localStorage.setItem("chest", id);
        window.location.hash = "#/mint/chest/" + id;
    }
}
